export enum EventPrepositionLabel {
  vs = 'vs.',
  at = 'at',
}

export enum ResultLabel {
  Win = 'W',
  Loss = 'L',
  Tie = 'T',
}

export enum Status {
  Cancelled = 'cancelled',
  Closed = 'closed',
  Complete = 'complete',
  Created = 'created',
  Delayed = 'delayed',
  FlexSchedule = 'flex-schedule',
  Halftime = 'halftime',
  InProgress = 'inprogress',
  Postponed = 'postponed',
  Scheduled = 'scheduled',
  Suspended = 'suspended',
  TimeTbd = 'time-tbd',
}

export const SCHEDULED_STATUSES: Status[] = [
  Status.Scheduled,
  Status.Created,
]

export const TBD_STATUSES: Status[] = [
  Status.TimeTbd,
  Status.FlexSchedule,
]

export const PRE_GAME_STATUSES: Status[] = [
  Status.Scheduled,
  Status.Created,
  Status.Delayed,
  Status.FlexSchedule,
  Status.TimeTbd,
]

export const IN_GAME_STATUSES: Status[] = [
  Status.InProgress,
  Status.Halftime,
]

export const POST_GAME_STATUSES: Status[] = [
  Status.Complete,
  Status.Closed,
  Status.Cancelled,
  Status.Postponed,
  Status.Suspended,
]

export enum StatusLabel {
  Scheduled = 'Scheduled',
  Created = 'Created',
  InProgress = 'Live',
  Halftime = 'Half',
  Complete = 'Final',
  Cancelled = 'Cancelled',
  Postponed = 'Postponed',
  Delayed = 'Delayed',
  Suspended = 'Suspended',
  TimeTbd = 'TBD',
  Closed = 'Closed',
}

export enum LinkType {
  PreEvent = 'pre_event',
  Recap = 'recap',
  PostEvent = 'post_event',
}
